import { LIGHT, MUTE, GOLD, BASE, BODY, MONO } from '../lib/constants';
import { Horizon, Btn, Dp, Bd, Mo, GlassCard } from './shared';

/* ═══════════════════════════════════════════════════════════════
   BATCH 7: Terms of Service Screen
   Required for Apple App Store approval
   ═══════════════════════════════════════════════════════════════ */

export function TermsScreen({ onBack }) {
  return (
    <div style={{ position: 'relative', minHeight: '100vh', background: BASE, padding: '20px 16px' }}>
      <Horizon intensity={0.3} />
      
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 600, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <button
            onClick={onBack}
            style={{
              background: 'transparent', border: 'none', color: GOLD,
              fontFamily: MONO, fontSize: 11, fontWeight: 600, cursor: 'pointer',
              marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6
            }}
            data-testid="back-btn"
          >
            ← BACK
          </button>
          <Dp style={{ fontSize: 28, fontWeight: 800, color: LIGHT, marginBottom: 8 }}>Terms of Service</Dp>
          <Bd style={{ fontSize: 13, color: MUTE }}>Last updated: January 2026</Bd>
        </div>

        {/* Content */}
        <div style={{ fontFamily: BODY, fontSize: 14, color: LIGHT, lineHeight: 1.8 }}>
          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>1. Acceptance of Terms</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              By accessing or using Dettio, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the service.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>2. Service Description</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              Dettio is a financial management tool that helps users track debts, analyze spending, and receive AI-powered financial insights. Dettio is not a bank, lender, or financial advisor. We do not provide financial advice and are not responsible for financial decisions you make based on the information provided.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>3. User Accounts</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              You are responsible for maintaining the confidentiality of your account credentials. You agree to provide accurate information and keep your account information up to date.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>4. Acceptable Use</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              You agree not to use Dettio for any unlawful purpose or in any way that could damage, disable, or impair the service. You may not attempt to gain unauthorized access to any part of the service.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>5. Intellectual Property</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              All content, features, and functionality of Dettio are owned by Juguitos LLC and are protected by copyright, trademark, and other intellectual property laws.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>6. Termination</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              We reserve the right to suspend or terminate your account at any time for violations of these Terms. You may delete your account at any time from the Settings screen.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>7. Disclaimer of Warranties</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              Dettio is provided "as is" without warranties of any kind. We do not guarantee that the service will be uninterrupted, secure, or error-free.
            </Bd>
          </GlassCard>

          <GlassCard style={{ marginBottom: 24 }}>
            <Dp style={{ fontSize: 18, fontWeight: 700, color: LIGHT, marginBottom: 12 }}>8. Contact</Dp>
            <Bd style={{ color: MUTE, lineHeight: 1.8 }}>
              For questions about these Terms, contact us at support@dettio.com
            </Bd>
          </GlassCard>
        </div>
      </div>
    </div>
  );
}
